module.exports = "https://r.nearpod.com/assets/media/image/math-icon-e2302c66075c3b44ba7150cd61fccfb6.svg";